import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { QueryParamsModel } from '../core/models/query-params.model';
import { IResponse } from '../core/interfaces/response.interface';
import { UserModel } from '../core/models/user.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(
    private http: HttpClient) {}

  readUsers(queryParams: QueryParamsModel): Observable<IResponse<UserModel[]>> {
    let query = {};
    query = { ...queryParams, filters: JSON.stringify(queryParams.filters) };

    return this.http.get<IResponse<UserModel[]>>(
      `${environment.apiUrl}/users`,
      {
        params: {
          ...query,
        },
      }
    );
  }

  readUserById(userId: number): Observable<IResponse<UserModel>> {
    return this.http.get<IResponse<UserModel>>(
      `${environment.apiUrl}/users/${userId}`
    );
  }

  updateUser(user: UserModel): Observable<null> {
    return this.http.put<null>(`${environment.apiUrl}/users/${user.id}`, user);
  }

  deleteUser(userId: number, version: number): Observable<null> {
    return this.http.delete<null>(
      `${environment.apiUrl}/users/${userId}/version/${version}`
    );
  }
}
